import { useQuery } from '@tanstack/react-query';
import * as dashboardApi from '@/api/dashboard';

export function useDashboardStats() {
  return useQuery({
    queryKey: ['dashboard', 'stats'],
    queryFn: dashboardApi.getStats,
    staleTime: 2 * 60 * 1000,
  });
}

export function useAnniversaries(daysAhead?: number, type?: string) {
  return useQuery({
    queryKey: ['dashboard', 'anniversaries', daysAhead, type],
    queryFn: () =>
      dashboardApi.getAnniversaries({ days_ahead: daysAhead, type }),
    staleTime: 10 * 60 * 1000,
  });
}

export function useRecentActivity() {
  return useQuery({
    queryKey: ['dashboard', 'recent-activity'],
    queryFn: dashboardApi.getRecentActivity,
    staleTime: 60 * 1000,
  });
}

export function useReportTrends() {
  return useQuery({
    queryKey: ['dashboard', 'report-trends'],
    queryFn: dashboardApi.getReportTrends,
    staleTime: 5 * 60 * 1000,
  });
}

export function useGdprStats() {
  return useQuery({
    queryKey: ['dashboard', 'gdpr-stats'],
    queryFn: dashboardApi.getGdprStats,
    staleTime: 2 * 60 * 1000,
  });
}

export function useRegistryStats() {
  return useQuery({
    queryKey: ['dashboard', 'registry-stats'],
    queryFn: dashboardApi.getRegistryStats,
    staleTime: 5 * 60 * 1000,
  });
}

export function useMemberBreakdowns(params?: {
  age_ranges_members?: string;
  age_ranges_dependents?: string;
}) {
  return useQuery({
    queryKey: ['dashboard', 'member-breakdowns', params],
    queryFn: () => dashboardApi.getMemberBreakdowns(params),
    staleTime: 5 * 60 * 1000,
  });
}
